import { FC, useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IClassroom } from '../../../models/classrooms.model';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import { Button as AntButton, Descriptions, Modal } from 'antd';
import Button from '../../Button';
import useAuth from '../../../hooks/useAuth';

interface IProps {
  classroom: IClassroom | null;
  onSubmit: Function;
  onDelete: Function | null;
}

const CampusClassroomEditor: FC<IProps> = ({ classroom, onSubmit, onDelete }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const history = useHistory();
  const location = useLocation();

  const [campus, setCampus] = useState<any>(null);
  const [name, setName] = useState('');
  const [memo, setMemo] = useState('');

  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

  const nameInput = useRef<any>();

  useEffect(() => {
    if (classroom) {
      setName(classroom.classroomName);
      setMemo(classroom.classroomMemo);
      setCampus(classroom.campusCode);
    } else {
      setCampus(currentCampus);
    }
  }, [classroom]);

  useEffect(() => {
    if (!classroom) {
      setCampus(currentCampus);
    }
  }, [currentCampus]);

  const onSave = async () => {
    if (!name) {
      nameInput.current.focus();
      return enqueueSnackbar(t('campus.classroom.message1'), {
        variant: 'info'
      });
    }

    if (classroom) {
      onSubmit({
        campusCode: campus,
        classroomName: name,
        classroomMemo: memo
      });
    } else {
      onSubmit(campus, {
        classroomName: name,
        classroomMemo: memo
      });
    }
  }

  return (
    <div className="comm-table__area rowType">
      <Descriptions bordered size="small" column={1} labelStyle={{ textAlign: 'center' }}>
        <Descriptions.Item label={`* ${t('campus.classroom.column2')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={name}
            onChange={e => setName(e.target.value)}
            ref={nameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('campus.classroom.column3')}>
          <input
            type="text"
            className="form-control input-text"
            value={memo}
            onChange={e => setMemo(e.target.value)}
          />
        </Descriptions.Item>
      </Descriptions>
      <div>
        {
          classroom
            ? (
              <div className="comm-bx__between">
                <div className="comm-btn__area">
                  <Button
                    onClick={() => history.push(`/campus/classroom${location.search}`)}
                    className="btn-basic gray-line"
                    text={t('common.button.list')}
                  />
                </div>
                <div className="comm-btn__area">
                  <Button
                    onClick={onSave}
                    className="btn-basic pink-line"
                    text={t('common.button.edit')}
                    writeAuthYn={writeAuthYn}
                  />
                  <Button
                    onClick={() => setConfirmDeleteVisible(true)}
                    className="btn-basic gray"
                    text={t('common.button.delete')}
                    writeAuthYn={writeAuthYn}
                  />
                </div>
              </div>
            )
            : (
              <div className="comm-bx__between">
                <div className="col-12 comm-btn__area right">
                  <Button
                    onClick={onSave}
                    className="btn-basic pink"
                    text={t('common.button.save')}
                    writeAuthYn={writeAuthYn}
                  />
                  <Button
                    onClick={() => history.push(`/campus/classroom${location.search}`)}
                    className="btn-basic gray"
                    text={t('common.button.cancel')}
                  />
                </div>
              </div>
            )
        }
      </div>

      {/* 강의실 삭제 모달 */}
      <Modal
        title={t('campus.classroom.title3')}
        visible={confirmDeleteVisible}
        onCancel={() => setConfirmDeleteVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                setConfirmDeleteVisible(false);
                if (onDelete) onDelete();
              }}
            >
              {t('common.button.delete')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setConfirmDeleteVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        {t('campus.classroom.text1')}
      </Modal>
    </div>
  )
}

export default CampusClassroomEditor;
